<script>
import CustomerFieldCheckbox from './customer_field_checkbox.vue';

export default {
  components: {
    CustomerFieldCheckbox
  },

  props: {
    documentText: {
      type: String,
      required: true
    },

    documentLink: {
      type: String,
      required: true
    },
  },
};
</script>

<template>
  <customer-field-checkbox
    name="customAgreement"
  >
    <span>
      {{ documentText }},

      <a
        :href="documentLink"
        target="_blank"
      >
        link
      </a>
    </span>
  </customer-field-checkbox>
</template>
